"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpenseFilterExportFormatEnum = void 0;
var ExpenseFilterExportFormatEnum;
(function (ExpenseFilterExportFormatEnum) {
    ExpenseFilterExportFormatEnum["CSV"] = "csv";
    ExpenseFilterExportFormatEnum["NOT_CSV"] = "not_csv";
    ExpenseFilterExportFormatEnum["DATEV_XML"] = "datev_xml";
    ExpenseFilterExportFormatEnum["NOT_DATEV_XML"] = "not_datev_xml";
    ExpenseFilterExportFormatEnum["DATEV_INVOICE_CSV"] = "datev_invoice_csv";
    ExpenseFilterExportFormatEnum["NOT_DATEV_INVOICE_CSV"] = "not_datev_invoice_csv";
    ExpenseFilterExportFormatEnum["DATEV_ONLINE"] = "datev_online";
    ExpenseFilterExportFormatEnum["NOT_DATEV_ONLINE"] = "not_datev_online";
    ExpenseFilterExportFormatEnum["ALL_DATEV"] = "all_datev";
    ExpenseFilterExportFormatEnum["NOT_ALL_DATEV"] = "not_all_datev";
})(ExpenseFilterExportFormatEnum || (exports.ExpenseFilterExportFormatEnum = ExpenseFilterExportFormatEnum = {}));
